<template>
  <v-container>
    <h1>Reviews</h1>
    <hr />

    <ReviewsTable
      :organization="organization"
      :filterOptions="filterOptions"
      :reviews="reviews"
      @edit="editReview" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ReviewsTable from './ReviewsTable'

export default {
  name: 'OrganizationReviews',
  components: {
    ReviewsTable,
  },
  props: {
    organizationId: String,
  },
  data: () => ({
    organization: {},
    products: [],
    reviews: [],
    filterOptions: [],
  }),

  computed: {
    ...mapGetters('feathers', ['apiOrganizations', 'apiProducts', 'apiReviews']),
  },

  created () {
    this.retrieveData()
  },

  methods: {
    async retrieveData () {
      try {
        const [organization, products, reviews] = await Promise.all([
          await this.apiOrganizations.get(this.organizationId, {
            query: { $include: { ReviewCount: true } },
          }),
          await this.apiProducts.find({
            query: { organizationId: this.organizationId },
          }),
          await this.apiReviews.find({
            query: {
              organizationId: this.organizationId,
              $scope: ['dashboard'],
            },
          }),
        ])

        this.organization = organization
        this.products = products
        this.reviews = reviews
      } catch (error) {
        this.addErrorAlert(`There was an error getting the data: ${error.message}`)
      }

      this.buildFilterOptions()
    },

    async editReview ({ id, finished, successMessage, ...data }) {
      try {
        const index = this.reviews.findIndex(review => review.id === id)

        await this.apiReviews.patch(id, {
          ...data,
        })

        this.addSuccessAlert(successMessage || 'Your response to the review was saved')
        if (finished) finished()

        this.$set(this.reviews, index, Object.assign(
          this.reviews[index],
          { ...data },
        ))
      } catch (error) {
        this.addErrorAlert(`There was an error saving the response: ${error.message}`)
        if (finished) finished(false)
      }
    },

    buildFilterOptions () {
      this.filterOptions = [
        { key: 'all', text: 'All Loan Product Reviews' },
        ...this.products
          .filter(({ id }, index) => {
            return this.products.findIndex(product => product.id === id) === index
          })
          .map(({ internalName, title }) => ({
            key: title, text: internalName || title,
          })),
      ]
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
